import styled from 'styled-components';

export const OverlayWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: 900;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: ${({ theme }) => theme.colors.surface.surface};
  color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  font-size: 14px;
  text-align: center;
  padding: 0 24px;
`;
